import { createContext, useContext } from 'react';

export type DropdownContext = {
  size: 'sm' | 'md' | 'lg' | 'xl';
  split: boolean;
  color: 'dark' | 'light' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger';
  purpose: 'primary' | 'outline' | 'default' | 'discreet' | 'flat' | 'link';
};

export const DropdownContext = createContext<DropdownContext>({
  size: 'md',
  split: false,
  color: 'primary',
  purpose: 'primary',
});

export const useDropdownContext = () => useContext(DropdownContext);
